module.exports = __webpack_public_path__ + "static/media/dynamics365Logo.59ca01db.svg";